const HEX_COLOR = /^#[0-9A-Fa-f]{6}$/

export const BRAND_LIGHT_INK = '#17101F'
export const BRAND_DARK_INK = '#FFFFFF'

function linearChannel(value: number) {
  const channel = value / 255
  return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4
}

function luminance(hex: string) {
  const red = Number.parseInt(hex.slice(1, 3), 16)
  const green = Number.parseInt(hex.slice(3, 5), 16)
  const blue = Number.parseInt(hex.slice(5, 7), 16)
  return 0.2126 * linearChannel(red) + 0.7152 * linearChannel(green) + 0.0722 * linearChannel(blue)
}

export function normalizeBrandColor(value: string | null | undefined) {
  return value && HEX_COLOR.test(value) ? value.toUpperCase() : null
}

export function brandContrastRatio(foreground: string, background: string) {
  const normalizedForeground = normalizeBrandColor(foreground)
  const normalizedBackground = normalizeBrandColor(background)
  if (!normalizedForeground || !normalizedBackground) return 1
  const foregroundLuminance = luminance(normalizedForeground)
  const backgroundLuminance = luminance(normalizedBackground)
  const lighter = Math.max(foregroundLuminance, backgroundLuminance)
  const darker = Math.min(foregroundLuminance, backgroundLuminance)
  return (lighter + 0.05) / (darker + 0.05)
}

export function readableBrandInk(background: string, preferred?: string | null) {
  const normalizedBackground = normalizeBrandColor(background)
  if (!normalizedBackground) return BRAND_DARK_INK
  const normalizedPreferred = normalizeBrandColor(preferred)
  if (normalizedPreferred && brandContrastRatio(normalizedPreferred, normalizedBackground) >= 4.5) return normalizedPreferred
  return brandContrastRatio(BRAND_LIGHT_INK, normalizedBackground) >= brandContrastRatio(BRAND_DARK_INK, normalizedBackground)
    ? BRAND_LIGHT_INK
    : BRAND_DARK_INK
}
